/**
 * ? @description : App Slice File is Created for Snackbar
 */

// Dependency
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    snackbar: {
      message: "",
      severity: "",
      open: false,
    },
  },
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      // state.value.snackbar = {
      //   ...initialState.value.snackbar,
      //   ...action.payload,
      //   open: true,
      // };
      state.value.snackbar = action.payload;
      state.value.snackbar.open = true;
    },

    hideSnackbar: (state, action) => {
      state.value.snackbar.open = false;
    },

    resetSnackbar: () => initialState
  },
});

export const { showSnackbar, hideSnackbar, resetSnackbar } = appSlice.actions;

export default appSlice.reducer;
